import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ClinicalExamEntryComponent } from '../clinical-exam-entry/clinical-exam-entry.component';
import { ClinicalExamModel } from 'src/app/models/ClinicalExamModel';
import { ClinicalExamService } from 'src/app/services/ClinicalExamService';
import swal from 'sweetalert2';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';


@Component({
  selector: 'app-clinical-exam-tab',
  templateUrl: './clinical-exam-tab.component.html',
  styleUrls: ['./clinical-exam-tab.component.css']
})
export class ClinicalExamTabComponent implements OnInit {

  patientcode = '' ;
    Patientname = '';

    examdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
    examlocation = '' ;
    examperfstatus = '' ;
    examnotes = '' ;
    userid = '' ;
    username = '' ;
    wk_font = 2;
    wk_fontsize = '2ch';
    clinicalexamList : ClinicalExamModel[]=[];
    disablepharnacy = false;
    chkuser = '';
    examlocationtext  = [];
    editorConfigNoToolbar = {
      editable: false,
      spellcheck: true,
      showToolbar: false,  // 🚫 This hides the toolbar
      height: 'auto',
      frameElement:false,
      minHeight: '0',
      width: '850px',
      placeholder: '',
      translate: 'no',
      defaultParagraphSeparator: '',
      defaultFontName: '',

      toolbarHiddenButtons: []
    };
    constructor(public clinicalexam: ClinicalExamModel,private dialogref: MatDialog,
                public storage: LocalStorageService,
                public companyService : CompanyService,
                public cliniclexamService :ClinicalExamService,
    ) { }

    ngOnInit(): void {
     /////************ */
     this.patientcode = this.storage.retrieve('stgPatientCode');
     this.Patientname = this.storage.retrieve('stgPatientName');
     this.examdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
     this.RetriveClinicalExam();
     if(this.storage.retrieve('stgGroup') !='2' && this.storage.retrieve('stgGroup') !='8'){this.disablepharnacy = true}else{this.disablepharnacy = false}

    }
    ZoomIn(){
      this.wk_font  = this.wk_font  + 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }
    ZoomOut(){
      this.wk_font  = this.wk_font  - 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }
    RetriveClinicalExam(){
      this.clinicalexamList = [];
      this.cliniclexamService.getClinicalExamPatient(this.patientcode).subscribe((data: ClinicalExamModel[]) => {
            for (let i = 0; i < data.length; i++) {
              this.clinicalexamList[i] = data[i];
              this.clinicalexamList[i].examdate =formatDate(data[i].examdate, 'yyyy-MM-dd', 'en');

               this.companyService.getcompany(data[i].examlocation).subscribe((data: CompanyModel) => {
                     this.examlocationtext[i] = data.compName;
                 });
             }

            }
          )
    }
  EditCliniclExam(item: ClinicalExamModel){
    this.chkuser = item.username;
    if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
      {                            ///----------- for searching pop up send variables from table-----------
    this.storage.store('stgPatientCode',item.patientcode);
    this.storage.store('stgVisitDate',item.examdate)
    if(this.storage.retrieve('stgGroup') == '8'){
      this.storage.store('stgUserIdId',item.userid)
      this.storage.store('stgUsernamename',item.username);

    }
    else
    {
      this.storage.store('stgUserIdId',this.storage.retrieve('stgUserId'));
      this.storage.store('stgUsernamename',this.storage.retrieve('stgUsername'));

    }
    const dialogRef = this.dialogref.open(ClinicalExamEntryComponent,
      {
        data: {
          dataKey: this.clinicalexam,
        },
        width: '50vw',
        height: '35vw',
      });
    dialogRef.afterClosed().subscribe(result => {
    this. RetriveClinicalExam();
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveClinicalExam();
        dialogSubmitSubscription.unsubscribe();
      });
    }
    else
    {
     this.MesgWarrning();
    }
  }
    MesgWarrning(){

      swal({
        title: 'Check User',
        text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK',
        //cancelButtonText: 'No, keep it',
      })
      ;

    }
  DeleteClinicExam(){

      this.cliniclexamService.deleteClinicalExam(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode'),this.userid).subscribe(
          (data: ClinicalExamModel) => {
            this.RetriveClinicalExam();
          }
        );
        this. RetriveClinicalExam();
  }
  openDialog(){if(this.patientcode !='0000' && this.patientcode != '' ){

    var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')
    this.storage.store('stgVisitDate',wk_Date )
    this.storage.store('stgUserIdId',this.storage.retrieve('stgUserId'));
    this.storage.store('stgUsernamename',this.storage.retrieve('stgUsername'));

      const dialogRef = this.dialogref.open(ClinicalExamEntryComponent,
        {
          data: {
            dataKey: this.clinicalexam
          },
          width: '50vw',
          height: '35vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetriveClinicalExam();
      });

      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.RetriveClinicalExam();
          dialogSubmitSubscription.unsubscribe();
        });
      }
    }
  MessegeDelete(item: ClinicalExamModel){
    this.chkuser = item.username;
    if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
      {
      swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover this record!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
          }).then(
            () => {
              this.storage.store('stgPatientCode',item.patientcode);
              this.storage.store('stgVisitDate',item.examdate)
              this.userid = item.userid;
              this.DeleteClinicExam();
              swal('Deleted!', 'Your record has been deleted.', 'success');
            },
            function (dismiss) {
              if (dismiss === 'cancel') {
                swal('Cancelled', 'Your record is safe :)', 'error');
              }
            }
          );
        }
        else
        {
          this.MesgWarrning();
        }
    }
  }

